import { defineCountry } from '../../../src/domain/country/factory';
import * as languages from '../../languages';

export default defineCountry({
  countryName: 'Turkey',
  countryCode: 'TR',
  countryHeaderCode: 'tr',
  mobileRegex: /^(?:\+90|0090|0)?5\d{9}$/,
  mobileLength: 10,
  mobileCode: '+90',
  consentForCallback: {
    shouldShow: true,
    isRequired: true,
  },
  languages: {
    [languages.tr.languageCode]: {
      bookingFlowConfig: {
        isDesktopBkfEnabled: true,
        isMobileBkfEnabled: true,
      },
      defaultAgreedDocs: {
        tncUrl: '/tr-TR/terms-of-service',
        privacyPolicyUrl: '/tr-TR/privacy-policy',
      },
      isSignupConsentRequired: true,
      currencyConfig: {
        currencyLocale: 'tr-TR',
        currencyCode: 'TRY',
        maxMinorDigits: 2,
        currencySymbol: '₺',
      },
    },
    [languages.en.languageCode]: {
      bookingFlowConfig: {
        isDesktopBkfEnabled: true,
        isMobileBkfEnabled: true,
      },
      isSignupConsentRequired: true,
      defaultAgreedDocs: {
        tncUrl: '/en-TR/terms-of-service',
        privacyPolicyUrl: '/en-TR/privacy-policy',
      },
      currencyConfig: {
        currencyLocale: 'en-TR',
        currencyCode: 'TRY',
        maxMinorDigits: 2,
        currencySymbol: '₺',
      },
    },
  },
  defaultLanguage: languages.tr,
  googleAutoCompletePlacesCode: 'tr',
  trackOrderContactSupportNumber: '+908502003097',
});
